import type { Message } from './store';
import { store } from './store';

export function addUserMessage(text: string) {
  const timestamp = Date.now();
  store.chatMessages = [
    ...store.chatMessages,
    { role: 'user', text, timestamp },
  ];
}

export function addAiMessage(text: string) {
  const timestamp = Date.now();
  store.chatMessages = [...store.chatMessages, { role: 'ai', text, timestamp }];
}

export function updateLastAiMessage(text: string) {
  store.chatMessages = store.chatMessages.map((msg, idx, arr) => {
    if (msg.role === 'ai' && msg.text === '...' && idx === arr.length - 1) {
      return { ...msg, text };
    }
    return msg;
  });
}

export function resetChatMessages() {
  store.chatMessages = [];
}
